import { stringify } from "querystring";

export class ClienteModel{

    id:Number;
    customerType:String;
    displayName:String;
    group:String;
    vatNumber:String;
    address1:String;
    address2:String;
    zipCode:String;
    state:String;
    city:String;
    country:String;
    telMobile:String;
    telHome:String;
    email:String;
    activo:Boolean;
    navNo:String;
    contratoID: number;

    public constructor(){
        this.id = null;
        this.customerType = null;
        this.displayName = null;
        this.group = null;
        this.vatNumber = null;
        this.address1 = null;
        this.address2 = null;
        this.zipCode = null;
        this.state = null;
        this.city = null;
        this.country = null;
        this.telMobile = null;
        this.telHome = null;
        this.email = null;
        this.activo = null;
        this.navNo = null;
        this.contratoID = null;    
    }
}